export default __webpack_public_path__ + "static/media/Simhachalam.5eb55b06.webp";